import { Component } from '@angular/core';

@Component({
    template: ``,
    styles: [``],
    standalone: false
})
export class DefaultSideNavComponent {}
